//  弹窗

// snippets 文件下 product-detail-swiper start 的js代码

function productDetailSwiper() {
  const sectionId = document.querySelector(".product-detail-swiper-container")
    .dataset.sectionId;
  // 弹窗el
  const modalContainer = document.getElementById("global-modal-" + sectionId);

  let productDetail = {
    // 监听点击产品轮播 slide事件弹出窗口
    listeningSlideEvents: function (galleryTop, modalContainer) {
      $(".product-detail-swiper-container .gallery-top .swiper-slide").on(
        "click",
        function () {
          modalContainer.open();
          productDetail.initModalSwiper(this.dataset.index, galleryTop);
        }
      );
    },
    productForm_swiper: function (swiper) {
      // 轮播图关联表单交互
      const { ptId: PRODUCT_ID } =
        document.getElementById("product-detail-swiper-container").dataset ??
        {};
      const currentVariantJson = JSON.parse(
        document.getElementById("current_variantJson-" + PRODUCT_ID)
          ?.innerText ?? "{}"
      );
      const variantsJson = JSON.parse(
        document.getElementById("VariantsJson-" + PRODUCT_ID)?.innerText ?? "{}"
      );
      const swiper_slide = getSwiperSlide();
      // 监听表单套餐类型变化
      let add_cart_form = document.querySelector("#product-form-" + sectionId);
      add_cart_form.addEventListener(
        "change",
        (e) => {
          const featured_media_id = variantsJson.find(
            (item) => item.id == e.target.value
          )?.featured_media?.id;

          if (featured_media_id) initSelectSlide(featured_media_id);
        },
        false
      );

      // 页面初始化选中
      function initSelectSlide(featured_media_id) {
        let slide_item = swiper_slide.find((t) => t.id == featured_media_id);
        if (!!slide_item) {
          slideTo(slide_item.index);
        }
      }

      if (currentVariantJson?.featured_media?.id) {
        initSelectSlide(currentVariantJson.featured_media.id);
      }

      function slideTo(index) {
        swiper.slideTo(index);
      }

      function getSwiperSlide() {
        const swiper_slide = [];
        $(".product-detail-swiper-content .gallery-top .swiper-slide").each(
          function () {
            swiper_slide.push({
              id: this.getAttribute("data-id"),
              index: this.getAttribute("data-index"),
            });
          }
        );
        return swiper_slide;
      }
    },
    initModalSwiper: (index, swiper) => {
      new Swiper("._product-detail-modal_ .modal_gallery-top", {
        spaceBetween: 0,
        slidesPerView: 1,
        initialSlide: index,
        // autoHeight: true,
        // zoom: true,
        loop: false,
        autoScrollOffset: 1,
        navigation: {
          nextEl: ".swiper-button-next-product",
          prevEl: ".swiper-button-prev-product",
        },
        on: {
          slideChange: function (item) {
            swiper.slideTo(item.activeIndex);
          },
        },
        thumbs: {
          swiper: {
            el: "._product-detail-modal_ .modal_gallery-thumbs",
            spaceBetween: 10,
            slidesPerView: 6,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
              //当swiper宽度大于等于768
              769: {
                slidesPerView: 7,
                spaceBetween: 10,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
              },
            },
          },
        },
      });
    },
  };

  let galleryTop = new Swiper(".product-detail-swiper-container .gallery-top", {
    spaceBetween: 0,
    slidesPerView: 1,
    // zoom: true,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next-product",
      prevEl: ".swiper-button-prev-product",
    },
    thumbs: {
      swiper: {
        el: ".product-detail-swiper-content .gallery-thumbs",
        spaceBetween: 10,
        slidesPerView: 6,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        breakpoints: {
          //当swiper宽度大于等于768
          769: {
            slidesPerView: 7,
            spaceBetween: 10,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
          },
        },
      },
      autoScrollOffset: 1,
    },
  });

  productDetail.productForm_swiper(galleryTop);
  productDetail.listeningSlideEvents(galleryTop, modalContainer);
}

// 产品头部轮播图+ 视频tab切换
function initProductVideoTab() {
  $(".product-detail-swiper-tab .detail-swiper-tab-item").on(
    "click",
    function () {
      const detail_video = document.getElementById("_detail_video_");
      $(".product-detail-swiper-tab .detail-swiper-tab-item")
        .not($(this))
        .removeClass("swiper-tab-item-active");
      $(this).addClass("swiper-tab-item-active");
      let data_id = $(this).attr("data-id");
      if (data_id === "photos") {
        detail_video && detail_video.pause();
        $(".product-detail-swiper-content .product-detail-video").hide();
        $(".product-detail-swiper-content .swiper-container").show();
        $(".product-detail-swiper-content .product-model_3d").hide();
      } else if (data_id === "model-3d") {
        detail_video && detail_video.pause();
        $(".product-detail-swiper-content .product-detail-video").hide();
        $(".product-detail-swiper-content .swiper-container").hide();
        $(".product-detail-swiper-content .product-model_3d").show();
      } else if (data_id === "video") {
        $(".product-detail-swiper-content .product-detail-video").show();
        $(".product-detail-swiper-content .swiper-container").hide();
        $(".product-detail-swiper-content .product-model_3d").hide();
      }
    }
  );
}

// snippets 文件下 discount-card  的js代码 start

function getKlarnaDom() {
  let klarna_placement_root = document.querySelector("klarna-placement div");
  if (klarna_placement_root) {
    let style = document.createElement("style");
    style.innerHTML = `
          .container{
            border: none;
            padding: 0;
            margin-top: 10px;
          }
          .badge svg{
            width: 40px;
            height: 24px;
          }
          .text-wrapper p{
            display: flex;
          }
          .link{
            color: #1890FF;
          }`;
    klarna_placement_root.shadowRoot.appendChild(style);
  }
  return klarna_placement_root;
}

let time_sum = 0;
let time_kl = setInterval(() => {
  let kl = getKlarnaDom();
  time_sum += 1;
  if (!!kl || time_sum > 20) {
    clearInterval(time_kl);
  }
}, 1000);
// snippets 文件下 discount-card  的js代码 end
window.addEventListener(
  "DOMContentLoaded",
  () => {
    productDetailSwiper();
    initProductVideoTab();
    updataShopBtn();
  },
  false
);

function updataShopBtn() {
  window.__btn_shop__ = setInterval(() => {
    const btnShop = document.querySelector(
      ".product-form__buttons .shopify-payment-button__button > div > div > span:first-child"
    );
    if (btnShop) {
      btnShop.innerText = "Jetzt kaufen mit ";
      const img = new Image();
      img.src =
        "https://cdn.shopify.com/s/files/1/0687/8144/1332/files/ShopPay.svg?v=1679312228";
      img.alt = "shop-icon";
      btnShop.appendChild(img);
      clearInterval(window.__btn_shop__);
    }
  }, 500);
}
